export default {
    path: 'zfcg',
    component: () => import(/*webpackChunkName: 'bidding-projectflow-dingbiao-zhongbiaogg-zfcg'*/ '@layout/empty'),
    children: [
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/ding/zhongbiaogg/zfcg/detail'),
            meta: {
                title: '查看中标公告',
            },
        }        
    ]
}